export default {
  leagues: {
    title: "Choisir une ligue",
    empty: {
      favoriteLeagues: "Ajoute tes ligues favorites en haut pour y accéder plus rapidement",
    },
    actions: {
      starFavoriteLeagues: "Ajouter des ligues favorites",
    },
    status: {
      live: "Actif",
      offseason: "Hors saison",
    },
    sections: {
      myLeagues: "Mes ligues",
      sports: {
        baseball: "Baseball",
        basketball: "Basketball",
        football: "Football",
        "australian-football": "Football australien",
        rugby: "Rugby",
        hockey: "Hockey",
        soccer: "Soccer",
      },
    },
  },
};
